// users, dayjs, Districts
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { cloneDeep } from "lodash";

dayjs.extend(utc);
dayjs.extend(timezone);



// month filters
// weired naming
const monthFiltersArray = [
  "One",
  "Second",
  "Third",
  "Fourth",
  "fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Delivered",
];

const monthFilters = monthFiltersArray.map((m) => {
  return {
    _id: m,
    name: m,
  };
});

const TrimesterMap = {
  1: "First",
  2: "Second",
  3: "Third",
  4: "Fourth",
  5: "Delivered",
  "-1": "Declined",
};

export const filterColumns = (
  filters,
  filter,
  setFilter,
  { Districts, users, map }
) => {
  // POssible columns
  const PossibleColumns = [
    {
      id: "_id",
      label: "ID",

      editable: true,
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      field: {
        name: "_id",
        type: "text",
        label: "ID",
      },
      state: filter,
    },
    {
      id: "motherID",
      label: "Mother ID",

      editable: true,
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      field: {
        name: "motherID",
        type: "text",
        label: "Mother ID",
      },
      state: filter,
    },
    {
      id: "name",
      label: "Name",

      editable: true,
      field: {
        name: "motherName",
        type: "text",
        label: "Name",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "bName",
      label: "Name",

      editable: true,
      field: {
        name: "bName",
        type: "text",
        label: "Name",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "pregnancyStatus",
      type: "select",

      isSelect: true,
      field: {
        multiple: true,
        name: "pregnancyStatus",
        type: "select",
        label: "Pregnancy Status",
        option: { key: "PregnancyStatus", value: "_id", label: "name" },
      },
      data: {
        PregnancyStatus: [
          // {
          //   _id: "Any",
          //   name:"Any"
          // },
          {
            _id: "Currently Expecting",
            name: "Currently Expecting",
          },
          {
            _id: "Delivered",
            name: "Delivered",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "uploadTypeDelivery",
      type: "select",

      isSelect: true,
      field: {
        // multiple: true,
        name: "uploadTypeDelivery",
        type: "select",
        label: "Upload Type Delivered",
        option: { key: "UploadTypeDelivered", value: "_id", label: "name" },
      },
      data: {
        UploadTypeDelivered: [
          // {
          //   _id: "Any",
          //   name:"Any"
          // },
          {
            _id: "any",
            name: "Any"
          },
          {
            _id: true,
            name: "Yes",
          },
          {
            _id: false,
            name: "No",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "contact",
      label: "Contact",

      format: (data, row) => {
        if (row) {
          if (row.contactNumbers && row.contactNumbers.length > 0) {
            return row.contactNumbers.join(",");
          } else {
            return data || "";
          }
        } else {
          return "";
        }
      },
      editable: true,
      field: {
        name: "contact",
        type: "text",
        label: "Contact",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "age",
      label: "Age",

      editable: true,
      field: {
        name: "age",
        type: "number",
        label: "Age",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "week",

      field: {
        name: "week",
        type: "number",
        label: "Week",
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      isSelect: true,
      id: "pregnancyMonth",
      field: {
        isSelect: true,
        name: "pregnancyMonth",
        type: "select",
        label: "Months",
        option: { key: "Months", value: "_id", label: "name" },
        value: "One",
        multiple: true,
      },
      data: {
        Months: [
          {
            _id: "",
            name: "Any",
          },
          ...monthFilters,
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "districtName",
      label: "District",

      width: 200,
      isSelect: true,
      field: {
        name: "district",
        type: "select",
        label: "District",
        multiple: true,
        option: { key: "Districts", value: "_id", label: "name" },
        noMb: true,
      },
      data: {
        Districts: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(Districts || []),
        ],
      },
      onChange: (name, value) => {
        let newFilter = cloneDeep(filter);
        newFilter[name] = value;
        console.log("-------------------------------->DD");
        setFilter({ ...newFilter });
      },
      state: cloneDeep(filter),
    },
    {
      id: "district",
      label: "District",

      isSelect: true,
      field: {
        name: "district",
        type: "select",
        label: "District",
        multiple: true,
        option: { key: "Districts", value: "_id", label: "name" },
        noMb: true,
      },
      data: {
        Districts: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(Districts || []),
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "agent",

      field: {
        name: "agent",
        type: "select",
        multiple: true,
        option: { key: "TelecallersTo", value: "_id", label: "name" },
        label: "Caller",
      },
      data: {
        TelecallersTo: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(users || []).filter((u) => {
            return u.roles.includes(process.env.REACT_APP_TELECALLER);
          }),
        ],
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      format: (data, row) => {
        if (map.users) {
          return map.users?.[data]?.name || data;
        }
        return data;
      },
      state: filter,
    },
    {
      id: "dataType",
      label: "Data Type",

      isSelect: true,
      format: (data, row) => {
        return data || "";
      },
      editable: true,
      field: {
        // name: "dataType",
        name: 'data_type',
        type: "select",
        label: "Data Type",
        multiple: true,
        option: { key: "DataType", value: "_id", label: "name" },
        noMb: true,
      },
      data: {
        DataType: [
          { _id: "any", name: "Any" },
          { _id: "followup_calls", name: "Follow-up calls" },
          // { _id: "followup_calls_delivered", name: "Follow-up calls(Delivered)" },
          { _id: "new_data", name: "New Data" },
          {
            _id: "previously_unreached",
            name: "Previously Unreached from previous months",
          },
          {
            _id: "previously_unattempted",
            name: "Previously Pending from previous months",
          },
          { _id: "delivered", name: "Delivered(Current Month)" },
          {
            _id: "previously_delivered",
            name: "Delivered(Not Current Month)",
          },
          {
            _id: "previously_unreached_delivered",
            name: "Previously Unreached from previous months(Delivered)",
          },
          {
            _id: "previously_unattempted_delivered",
            name: "Previously Pending from previous months(Delivered)",
          },
        ],
        // DataType: ["oldata", "newdata", "follow-up"].map((d) => ({
        //   _id: d,
        //   name: d,
        // })) || [],
        // ["oldata", "New Data", "Follow-ups"].map((d) => ({
        //   _id: d,
        //   name: d,
        // })) || [],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "firstReceived",
      label: "First Received",

      editable: true,
      format: (data, row) => {
        return data ? dayjs(data).format("DD-MM-YYYY") : "";
      },
      field: {
        name: "firstReceived",
        type: "date",
        label: "First Received",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "dateReceived",
      label: "Date Receieved",

      editable: true,
      format: (data, row) => {
        return data ? dayjs(data).format("DD-MM-YYYY") : "";
      },
      field: {
        name: "dateReceived",
        type: "date",
        label: "Date Received",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    // { id: "status", label: "Status", minWidth: 50 },
    {
      id: "motherStatus",
      label: "Mother Status",

      format: (data, row) => {
        // What is this why is it using childStatus why was motherStatus being updated 
        // And why is child status being used to show the data here
        // What is this undocumented piece of garbage code. 
        // This is a complete failure of a codebase.
        // God help the next person who has to look at this code.
        // Nice build
        return `${data || ""}  ${row.motherStatus ? "| 	" + row.motherStatus : ""
          }`;
        // return `${data || ""}  ${row.childStatus ? "| 	" + row.childStatus : ""
        // }`;
      },
      isSelect: true,
      field: {
        name: "motherStatus",
        type: "select",
        label: "Mother Status",
        option: {
          key: "MotherStatus",
          value: "_id",
          label: "name",
        },
        noMb: true,
        multiple: true,
      },
      data: {
        MotherStatus: ["Currently Expecting", "Delivered", "Not Delivered"].map((d) => ({
          _id: d,
          name: d,
        })),
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "callStatus",
      isSelect: true,
      field: {
        name: "callStatus",
        type: "select",
        label: "Call Status",
        option: { key: "CallStatus", value: "_id", label: "name" },
        multiple: true,
      },
      data: {
        CallStatus: [
          {
            _id: "",
            name: "Any",
          },
          {
            _id: "Call done",
            name: "Call Done",
          },
          {
            _id: "Not In The Portal",
            name: "Not In The Portal",
          },
          {
            _id: "Deceased child",
            name: "Deceased Child",
          },
          {
            _id: "Deceased mother",
            name: "Deceased Mother",
          },
          {
            _id: "Busy",
            name: "Busy",
          },
          {
            _id: "Language Barrier",
            name: "Language Barrier",
          },
          {
            _id: "Completed",
            name: "Completed",
          },
          {
            _id: "Switched Off",
            name: "Switched Off",
          },
          {
            _id: "Declined",
            name: "Declined",
          },
          {
            _id: "Incoming not available",
            name: "Incoming not available",
          },
          {
            _id: "No answer",
            name: "No answer",
          },
        ],
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "previouCallStatus",
      type: "select",

      isSelect: true,
      field: {
        multiple: true,
        name: "previouCallStatus",
        type: "select",
        label: "Last Call Status",
        option: { key: "PreviousCallStatus", value: "_id", label: "name" },
      },
      data: {
        PreviousCallStatus: [
          {
            _id: "",
            name: "Any",
          },
          {
            _id: "Call done",
            name: "Call Done",
          },
          {
            _id: "Not In The Portal",
            name: "Not In The Portal",
          },
          {
            _id: "Deceased Child",
            name: "Deceased Child",
          },
          {
            _id: "Deceased Mother",
            name: "Deceased Mother",
          },
          {
            _id: "Busy",
            name: "Busy",
          },
          {
            _id: "Language Barrier",
            name: "Language Barrier",
          },
          {
            _id: "Completed",
            name: "Completed",
          },
          {
            _id: "Switched Off",
            name: "Switched Off",
          },
          {
            _id: "Declined",
            name: "Declined",
          },
          {
            _id: "Incoming not available",
            name: "Incoming not available",
          },
          {
            _id: "No answer",
            name: "No answer",
          },
          {
            _id: "No network",
            name: "No network",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    // {
    //   id: "nextCallDue",
    //   label: "Next Call Due",
    //   minWidth: 50,
    //   format: (data, row) => {
    //     return data ? dayjs(data).format("DD-MM-YYYY") : "NA";
    //   },
    // },

    {
      id: "cluster",
      field: {
        name: "cluster",
        type: "text",
        label: "Cluster",
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "childDeliveryPlace",
      isSelect: true,
      field: {
        name: "childDeliveryPlace",
        type: "select",
        label: "Delivery Place",
        option: { key: "DeliveryPlace", value: "_id", label: "name" },
        multiple: true,
      },
      data: {
        DeliveryPlace: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Currently expecting",
            name: "Currently expecting",
          },
          {
            _id: "Delivered at home",
            name: "Delivered at home",
          },
          {
            _id: "Institutional Delivery",
            name: "Institutional Delivery",
          },
          {
            _id: "Connected-Call incomplete",
            name: "Connected-Call incomplete",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      isSelect: true,
      id: "homeDeliverReason",
      field: {
        name: "homeDeliverReason",
        type: "select",
        label: "Home Deliver Reason",
        option: {
          key: "HomeDeliverReason",
          value: "_id",
          label: "name",
        },
        multiple: true,
      },
      data: {
        HomeDeliverReason: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Currently expecting",
            name: "Currently expecting",
          },
          {
            _id: "Deliveries at home",
            name: "Deliveries at home",
          },
          {
            _id: "Institutional Delivery",
            name: "Institutional Delivery",
          },
          {
            _id: "Unexpected Labour pains",
            name: "Unexpected Labour pains",
          },
          {
            _id: "Unwilling",
            name: "Unwilling",
          },
          {
            _id: "Connected-Call incomplete",
            name: "Connected-Call incomplete",
          },
          {
            _id: "ASHA/ ANM unsure of the reason",
            name: "ASHA/ ANM unsure of the reason",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "childImmunization",

      isSelect: true,
      field: {
        name: "childImmunization",
        type: "select",
        label: "Child Immunized?",
        option: {
          key: "ChildImmunization",
          value: "_id",
          label: "name",
        },
        multiple: true,
      },
      data: {
        ChildImmunization: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Yes",
            name: "Yes",
          },
          {
            _id: "No",
            name: "No",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      isSelect: true,
      id: "nonImmunizedReason",
      field: {
        name: "nonImmunizedReason",
        type: "select",
        label: "Non Immunized Reason?",
        option: {
          key: "NonImmunizedReason",
          value: "_id",
          label: "name",
        },
        multiple: true,
      },
      data: {
        NonImmunizedReason: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Already taken",
            name: "Already taken",
          },
          {
            _id: "Currently expecting",
            name: "Currently expecting",
          },
          {
            _id: "Connected-Call incomplete",
            name: "Connected-Call incomplete",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      isSelect: true,
      id: "lessThen1Year",
      field: {
        name: "lessThen1Year",
        type: "select",
        label: "Less Then 1 Year",
        option: { key: "LessThen1Year", value: "_id", label: "name" },
        multiple: true,
      },
      data: {
        LessThen1Year: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Yes",
            name: "Yes",
          },
          {
            _id: "No",
            name: "No",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      isSelect: true,
      id: "between1And2",
      field: {
        name: "between1And2",
        type: "select",
        label: "Between 1 and 2",
        option: { key: "Between1And2", value: "_id", label: "name" },
        multiple: true,
      },
      data: {
        Between1And2: [
          // {
          //   _id: "",
          //   name: "Any",
          // },
          {
            _id: "Yes",
            name: "Yes",
          },
          {
            _id: "No",
            name: "No",
          },
        ],
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "advice",
      field: {
        name: "advice",
        type: "text",
        label: "Advice",
      },

      onChange: (name, value) => {
        filter[name] = value;
        // debounced({ ...filter });
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "nextCallDue",
      label: "Next Call Due",

      format: (data, row) => {
        return data ? dayjs(data).format("DD-MM-YYYY") : "NA";
      },
      editable: true,
      field: {
        name: "nextCallDue",
        type: "date",
        label: "Next Call Due Date",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "status",

      isSelect: true,
      format: (data, row) => {
        return data; //== "Queue" ? "Pending" : data == "Pending" ? "Queue" : data;
      },
      editable: true,
      field: {
        name: "status",
        type: "select",
        label: "Status",
        multiple: true,
        option: { key: "Status", value: "_id", label: "name" },
        noMb: true,
      },
      data: {
        Status: [
          // "Unattempted",
          "Queue",
          "Pending",
          "Active",
          "No answer",
          "Call done",
          "Busy",
          "No network",
          "Invalid",
          "Incoming not available",
          "Not in the portal",
          "Miscarriage",
          "Call Incomplete",
          "Deceased Child",
          "Switched off",
          "Wrong number",
          "Declined",
          "Out of service",
          "Language Barrier",
          "Deceased Mother",
          "Deceased (Mother and Child)",
          "Duplicate Mother Id",
          "Child Above 2 Years",
          "Completed",
          "Not Pregnant"
        ].map((d) => ({ _id: d, name: d })),
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    // {
    //   id: "status",
    //   label: "Remarks",
    //   minWidth: 50,
    //   format: (data, row) => {
    //     return "";
    //   },
    // },

    {
      id: "attempt",
      label: "Attempt",

      format: (data, row) => {
        return data || "";
      },
      editable: true,
      field: {
        name: "attempt",
        type: "number",
        label: "No. of attempt",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "transferredFrom",
      format: (data, row) => {
        return map?.users?.[data]?.name || "";
      },
      isSelect: true,
      label: "Transferred From",

      field: {
        name: "transferredFrom",
        type: "select",
        label: "Transferred From",
        option: {
          key: "TelecallersFrom",
          value: "_id",
          label: "name",
        },
        multiple: true,
      },
      editable: true,
      data: {
        TelecallersFrom: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(users || []).filter((u) => {
            return u.roles.includes(process.env.REACT_APP_TELECALLER);
          }),
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "comments",
      label: "Remarks",

      width: 150,
      editable: true,
      field: {
        name: "comments",
        type: "text",
        label: "Remarks",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "transferStatus",
      label: "Remarks",

      editable: true,
      field: {
        name: "comments",
        type: "text",
        label: "Remarks",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "lastAttemptDate",
      label: "Last Attempted",

      editable: true,
      format: (data, row) => {
        return data ? dayjs.utc(data).tz('Asia/Kolkata').format("DD-MM-YYYY HH:mm:ss") : "";
      },
      field: {
        name: "lastAttemptDate",
        type: "date",
        label: "Last Attempted",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "highRisk",
      format: (data, row) => {
        return data;
      },
      isSelect: true,
      label: "High Risk",

      field: {
        name: "highRisk",
        type: "select",
        label: "High Risk",
        option: { key: "HighRisks", value: "_id", label: "name" },
        multiple: true,
      },
      editable: true,
      data: {
        HighRisks: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...["Yes", "No"].map((d) => ({ _id: d, name: d })),
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "trimester",
      format: (data, row) => {
        return data;
      },
      isSelect: true,
      label: "Trimester",

      field: {
        name: "trimester",
        type: "select",
        label: "Trimester",
        option: { key: "Trimesters", value: "_id", label: "name" },
        multiple: true,
      },
      editable: true,
      data: {
        Trimesters: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },

          ...Object.values(TrimesterMap).map((d) => ({ _id: d, name: d })),
          {
            _id: "Connected-Call incomplete",
            name: "Connected-Call incomplete",
          },
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "lastCallDate",
      label: "Last Call",

      format: (data, row) => {
        if (data) {
          return `${dayjs(data)
            // need to do this because of the timezone difference
            .subtract(dayjs().utcOffset(), "minute")
            .format("DD-MM-YYYY")} `;
        }
        return "NA";
      },
      editable: true,
      field: {
        name: "lastCallDate",
        type: "date",
        label: "Last Call",
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "allocatedToUser",
      format: (data, row) => {
        return map?.users?.[data]?.name || "";
      },
      isSelect: true,
      //  label: "AllocatedTo",

      field: {
        name: "allocatedToUser",
        type: "select",
        label: "Allocated To",
        option: { key: "TelecallersTo", value: "_id", label: "name" },
        multiple: true,
      },
      editable: true,
      data: {
        TelecallersTo: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(users || []).filter((u) => {
            return u.roles.includes(process.env.REACT_APP_TELECALLER);
          }),
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    // Required Allocated To User

    {
      id: "requiredAllocatedToUser",
      label: "Required Allocated To",
      format: (data, row) => {
        return map?.users?.[data]?.name || "";
      },
      // isSelect: true,
      // editable: null,
      // label: "AllocatedTo",

      minWidth: 200,
      field: {
        name: "requiredAllocatedToUser",
        type: "select",
        label: "Required Allocated To",
        option: { key: "RequiredTelecallersTo", value: "_id", label: "name" },
        multiple: true,
      },
      // editable: false,
      // editable: true,
      data: {
        RequiredTelecallersTo: [
          // {
          //   _id: "Any",
          //   name: "Any",
          // },
          ...(users || []).filter((u) => {
            return u.roles.includes(process.env.REACT_APP_TELECALLER);
          }),
        ],
      },
      onChange: (name, value) => {
        filter[name] = value;
        // setFilter({ ...filter });
      },
      state: filter,
    },

    // END Required Allocated To User
    {
      id: "ucid",
      format: (data, row) => {
        return data;
      },
      isSelect: true,
      //  label: "AllocatedTo",

      field: {
        name: "ucid",
        type: "select",
        label: "UCID",
        option: { key: "Ucid", value: "_id", label: "name" },
        // multiple: true
      },
      editable: true,
      data: {
        Ucid: ["Any", "Not null", "Null"].map((d) => ({ _id: d, name: d })),
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    {
      id: "audioLink",
      format: (data, row) => {
        return data;
      },
      isSelect: true,
      //  label: "AllocatedTo",

      field: {
        name: "audioLink",
        type: "select",
        label: "audioLink",
        option: { key: "AudioLink", value: "_id", label: "name" },
        // multiple: true
      },
      editable: true,
      data: {
        AudioLink: ["Any", "Not null", "Null"].map((d) => ({
          _id: d,
          name: d,
        })),
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "callDate",
      label: "Assigned on",

      editable: true,
      format: (data, row) => {
        return data ? dayjs.utc(data).tz('Asia/Kolkata').format("DD-MM-YYYY") : "";
      },
      field: {
        name: "callDate",
        type: "date",
        label: "Assigned On",
      },
      onChange: (name, value) => {
        // let modValue = dayjs(value).format("YYYY-MM-DD");
        filter[name] = value;
        // filter[name] = modValue;
        setFilter({ ...filter });
      },
      state: filter,
    },
    {
      id: "priority",
      label: "Priority",

      isSelect: true,
      format: (data, row) => {
        return data || "";
      },
      editable: true,
      field: {
        name: "priority",
        type: "select",
        label: "Priority",
        option: { key: "Priority", value: "_id", label: "name" },
        noMb: true,
        multiple: true,
      },
      data: {
        Priority: [
          // "Any",
          "New Data",
          "High Risk",
          "Trimester",
          "Caller",
          "Transferred",
        ].map((d) => ({ _id: d, name: d })),
      },
      onChange: (name, value) => {
        filter[name] = value;
        setFilter({ ...filter });
      },
      state: filter,
    },

    //   {
    //     id: "allocatedToUser",
    //     format: (data, row) => {
    //       return map?.users?.[data]?.name || "";
    //     },
    //     label: "AllocatedTo",
    //     minWidth: 70,
    //     field: {
    //       name: "telecaller",
    //       type: "select",
    //       label: "Allocated",
    //       option: { key: "Telecallers", value: "_id", label: "name" },
    //     },
    //     editable: true,
    //     data: {
    //       Telecallers: [
    //         {
    //           _id: "Any",
    //           name: "Any",
    //         },
    //         ...(users || []).filter((u) => {
    //           return u.roles.includes(process.env.REACT_APP_TELECALLER);
    //         }),
    //       ],
    //     },
    //     onChange: (name, value) => {
    //       filter[name] = value;
    //       setFilter({ ...filter });
    //     },
    //     state: filter,
    //   },
  ];
  // TODO

  const filteredGroup = filters.reduce((a, b) => {
    a[b.id] = b;
    return a;
  }, {});

  const returnedValue = PossibleColumns.filter((column) => {
    return filters.some((filterLocal) => filterLocal.id === column.id);
  }).map((possibleColumn) => {
    if (filteredGroup[possibleColumn.id].showFilter) {
      possibleColumn.editable = true;
      if (filteredGroup[possibleColumn.id].minWidth) {
        possibleColumn.minWidth = filteredGroup[possibleColumn.id].minWidth;
      }
    } else {
      possibleColumn.editable = false;
    }

    // check type if select
    if (
      filteredGroup[possibleColumn.id].type &&
      filteredGroup[possibleColumn.id].type === "select"
    ) {
      delete possibleColumn.label;
      possibleColumn.editable = false;
    }

    return possibleColumn;
  });

  // console.log("returned value", returnedValue);

  return returnedValue;
};
